/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { UpdateOnboardingDraftResponse, UpdateOnboardingLocationApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateOnboardingLocation: build.mutation<UpdateOnboardingDraftResponse, UpdateOnboardingLocationApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/onboarding/location`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateOnboardingLocationApi };
export const { useUpdateOnboardingLocationMutation } = injectedRtkApi;
